import { render, staticRenderFns } from "./PPcCarouselBanner.vue?vue&type=template&id=12af1279&scoped=true&"
import script from "./PPcCarouselBanner.vue?vue&type=script&lang=ts&"
export * from "./PPcCarouselBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PPcCarouselBanner.vue?vue&type=style&index=0&id=12af1279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af1279",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VSheet})
